module.exports = __webpack_public_path__ + "assets/align-left-active.7cc6e16e.svg";